module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/assessment_achievements/4@2x_4ee62994c50cf5e19cb0914cf6c602cc.png";